import { defineNuxtRouteMiddleware, navigateTo } from "#app";
import { USER_CENTER_BASE_PATH, legacyPathToUserCenterPath } from "~/user-center/routes";

export default defineNuxtRouteMiddleware((to) => {
  const normalizedPath = legacyPathToUserCenterPath(to.fullPath);

  if (normalizedPath === to.fullPath) {
    return;
  }

  if (!normalizedPath.startsWith(USER_CENTER_BASE_PATH)) {
    return;
  }

  return navigateTo(normalizedPath, { replace: true });
});
